import { ErrorMessage, useFormikContext } from 'formik'
import DropdownIcon from 'icon/dropdown'
import React from 'react'

export default function Select({
  name,
  placeholder,
  label,
  options = [],
  onSelect,
  value,
  className,
  required,
}) {
  const formik = useFormikContext()
  const inputProps = name ? formik.getFieldProps(name) : {}

  return (
    <div className="w-full">
      {label ? (
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium text-[#BA141B]"
        >
          {label || ''}
          {required ? ' *' : ''}
        </label>
      ) : null}

      <div className="relative w-full">
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <DropdownIcon className="w-5 h-5 text-[#BA141B]" />
        </div>

        <select
          value={value ?? ''}
          onChange={onSelect}
          placeholder={placeholder || ''}
          {...inputProps}
          className={`w-full truncate pr-10 p-2.5 text-sm text-gray-700 bg-white border border-[#BA141B] rounded-md shadow-sm outline-none appearance-none focus:border-[#F5821F] focus:ring-[#F5821F]/20 ${className}`}
        >
          <option disabled value="">
            {placeholder || 'Select option'}
          </option>
          {options.map((option) => (
            <option key={option.value} disabled={option.disabled} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {name && (
          <ErrorMessage
            name={name}
            component="div"
            className="text-xs text-red-600 font-light mt-1"
          />
        )}
      </div>
    </div>
  )
}